import { useRouterState } from '@tanstack/react-router'
import { HistoryTable } from 'bank-entity-history'
import { TableDataQa } from 'commons/types/enums'
import { Layer, PageSection } from 'ui/components'

import { useTemplatesDetailsContext } from '../context'

export const History = () => {
  const { routeApi, data } = useTemplatesDetailsContext()
  const navigate = routeApi.useNavigate()
  const routerState = useRouterState()

  const {
    history,
    historyTotalCount,
    form: { historyPage, historySize }
  } = data

  return (
    <PageSection title="History" anchor="history">
      <Layer rounded shadowed stretch>
        <HistoryTable
          dataQa={TableDataQa.DOCUMENT_TEMPLATE_HISTORY}
          items={history}
          pagination={{
            total: historyTotalCount,
            page: historyPage,
            size: historySize,
            onChange: (page: number, size: number) => {
              navigate({
                to: '.',
                search: (prev) => ({ ...prev, historyPage: page, historySize: size }),
                resetScroll: false
              })
            }
          }}
          loading={routerState.status === 'pending'}
        />
      </Layer>
    </PageSection>
  )
}
